import {
  Box,
  Button,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import React, { useContext, useState, useCallback } from "react";
import PropTypes from "prop-types";
import AgreementSyncGrid from "../components/AgreementSyncGrid";
import SyncIcon from "@mui/icons-material/Sync";
import { AuthContext } from "../AuthContext.jsx";
import axios from "../services/configs/axiosConfig.js";
import { DealerSearch } from "../components/DealerSearch.jsx";
import JBWDateLabel from "../components/JBWDateLabel.jsx";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`agmclm-tabpanel-${index}`}
      aria-labelledby={`agmclm-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `agmclm-tab-${index}`,
    "aria-controls": `agmclm-tabpanel-${index}`,
  };
}

const AgreementsSyncHome = () => {
  const { group } = useContext(AuthContext);
  const localDealer = JSON.parse(localStorage.getItem("dealer"))
  const [selectedDealer, setSelectedDealer] = useState(localDealer ? localDealer : null);
  const [enableSyncBtn, setEnableSyncBtn] = useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const [syncDate, setSyncDate] = useState(null);
  const [searchAgreementId, setSearchAgreementId] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const tabTypeToIndex = {
    nolocation: 0,
    unapproved: 1,
    approved: 2,
  };
  const handleChange = (event, newValue) => {
    setTabValue(newValue);

    // RESET SEARCH WHEN TAB CHANGES
    setSearchAgreementId("");
    setSearchInput("");

    // optional but recommended
    //setEnableSyncBtn(false); // reset "no data" state
  };

  const syncDataHandler = async () => {
    const url = `agreementsync/${selectedDealer.dealerId}/spcall`;
    //stDataSyncSpCall(selectedDealer.dealerId)
    try {
      axios
        .get(url)
        .then(
          (res) => {
            if (res.status === 200) {
              console.log("Agreement sync success");
            }
          },
          (err) => {
            console.log("unable to sync agreements service", err);
          }
        )
        .catch((err) => {
          console.error("Internal server error : ", err);
        });
    } catch (error) {
      console.error("Internal server error : ", error);
    }

    setEnableSyncBtn(true);
  };

  const emptyDataListHandle = useCallback((data) => {
    setEnableSyncBtn(data);
  }, []);

  const handleLastSyncDateChange = useCallback((date) => {
    setSyncDate(date);
  }, []);
  const handleClearSearch = () => {
    setSearchInput("");
    setSearchAgreementId("");
  };

  const handleSetParentTab = useCallback((type) => {
    const index = tabTypeToIndex[type];
    if (index !== undefined) {
      setTabValue(index);
    }
  }, []);
  const tabDisply = () => {
    return (
      <Box
        sx={{
          maxWidth: "100%",
          padding: 2,
          boxShadow: 4,
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          backgroundColor: "#fff",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="Agreements Sync Tabs"
          >
            <Tab label="Map Location" {...a11yProps(0)} />
            <Tab label="Pending Approval" {...a11yProps(1)} />
            <Tab label="Approved" {...a11yProps(2)} />
          </Tabs>
        </Box>
        {/* Replace the three CustomTabPanels with this logic */}
        <Box sx={{ p: 3 }}>
          {tabValue === 0 && (
            <AgreementSyncGrid
              key="nolocation"
              tabType="nolocation"
              dealer={group === "jbw-admin" ? selectedDealer.dealerId : selectedDealer.id}
              dealerName={selectedDealer.dealerName}
              onEmptyDataList={emptyDataListHandle}
              onLastSyncDateChange={handleLastSyncDateChange}
              setParentTab={handleSetParentTab}
              searchAgreementId={searchAgreementId}
              setSearchAgreementId={setSearchAgreementId}
            />
          )}
          {tabValue === 1 && (
            <AgreementSyncGrid
              key="unapproved"
              tabType="unapproved"
              dealer={group === "jbw-admin" ? selectedDealer.dealerId : selectedDealer.id}
              dealerName={selectedDealer.dealerName}
              onEmptyDataList={emptyDataListHandle}
              onLastSyncDateChange={handleLastSyncDateChange}
              setParentTab={handleSetParentTab}
              searchAgreementId={searchAgreementId}
              setSearchAgreementId={setSearchAgreementId}
            />
          )}
          {tabValue === 2 && (
            <AgreementSyncGrid
              key="approved"
              tabType="approved"
              dealer={group === "jbw-admin" ? selectedDealer.dealerId : selectedDealer.id}
              dealerName={selectedDealer.dealerName}
              onEmptyDataList={emptyDataListHandle}
              onLastSyncDateChange={handleLastSyncDateChange}
              setParentTab={handleSetParentTab}
              searchAgreementId={searchAgreementId}
              setSearchAgreementId={setSearchAgreementId}
            />
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box component="main">
      <Container maxWidth="xl">
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} lg={12}>
            <Box
              sx={{
                maxWidth: "100%",
                padding: 2,
                boxShadow: 4,
                borderRadius: 3,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                backgroundColor: "#fff",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      maxWidth: "100%",
                      padding: 1,
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Typography variant="h6" component="h6">
                      Agreements Sync <br />
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{ color: "#a8a8a8d4" }}
                      ></Typography>
                    </Typography>
                    {group === "jbw-admin" && (
                      <Box sx={{ position: "relative", marginLeft: 5 }}>
                        <DealerSearch type="syncSearch" onSelect={(value) => {
                          emptyDataListHandle(false);
                          console.log(
                            "Auto complete delaer value :",
                            value
                          );
                          if (!value) return;
                          setSelectedDealer(value);
                        }} />

                      </Box>
                    )}
                    {selectedDealer && (
                      <Box sx={{ position: "relative", marginLeft: 3 }}>
                        <TextField
                          size="small"
                          placeholder="Search Agreement ID"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              setSearchAgreementId(searchInput.trim());
                            }
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              width: 250,
                              height: 40,
                              paddingLeft: 1,
                              borderRadius: "20px",
                            },
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {/* Search Icon */}
                                <IconButton
                                  size="small"
                                  disabled={!searchInput.trim()}
                                  onClick={() => setSearchAgreementId(searchInput.trim())}
                                >
                                  <SearchIcon />
                                </IconButton>

                                {/* Clear Icon */}
                                {searchInput && (
                                  <IconButton size="small" onClick={handleClearSearch}>
                                    <ClearIcon />
                                  </IconButton>
                                )}
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                    )}
                    <Box sx={{ flexGrow: 1 }} />
                    {syncDate && (<Typography
                      variant="success"
                      component="subtitle1"
                      align="left"
                      sx={{ fontSize: "14px", mt: 1, mr: 3 }}
                    >Last Sync Date: <JBWDateLabel inputDate={syncDate} dateFormat="MMM.DD,YYYY" sx={{ alignSelf: "center", marginRight: 2 }} /> </Typography>)}
                     {(group === "jbw-admin" && selectedDealer) && (
                      <Box>
                        <Button
                          variant="contained"
                          color="secondary"
                          size="small"
                          sx={{
                            borderRadius: "50px",
                          }}
                          startIcon={<SyncIcon />}
                          onClick={syncDataHandler}
                        >
                          {syncDate && ("Re")}Sync Data
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Grid>
                <Box
                  sx={{
                    maxWidth: "100%",
                    padding: 1,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {selectedDealer && tabDisply()}
                </Box>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AgreementsSyncHome;
